import { useState } from "react";
import Form from "./components/Form/Form";
import Results from "./components/Results/Results";

function InterestRateApp() {
  const [interestRateData, setInterestRateData] = useState({
    formData: {
      loanAmount: '5000',
      loanTerm: '60',
      monthlyPayment: '100'
    },
    results: {
      interestRate: '',
      totalMonthlyPayments: '',
      totalInterest: ''
    }
  });

  return (
    <div className="InterestRateApp">
      <Form formData={interestRateData.formData} setInterestRateData={setInterestRateData} />
      <Results results={interestRateData.results} />
    </div>
  );
}

export default InterestRateApp;
